import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import * as feather from 'feather-icons';
import { AuthService } from './services/auth.service';
import { NavigationEnd, Router } from '@angular/router';
import { AnalyticsService } from './services/analytics.service';
import { ThemeService } from './services/theme.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  title = 'divisas-web-app';
  isHome = false;

  @ViewChild('smartScroll') smartScrollRef?: ElementRef<HTMLElement>;
  private navbarResizeObserver?: ResizeObserver;
  private magicLinkRedirected = false;

  constructor(
    public readonly isAuth: AuthService,
    private readonly _analyticsService: AnalyticsService,
    public router: Router,
    private readonly theme: ThemeService,
  ) {
    this.isHome = this.isHomeUrl(this.router.url);

    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.isHome = this.isHomeUrl(event.urlAfterRedirects);
        this._analyticsService.trackUrl(event.url);
        if (!this.magicLinkRedirected) {
          this.magicLinkRedirected = true;
          this.openMagicLinkFromHash();
        }
      });
  }

  ngOnInit(): void {
    this.theme.init();
    feather.replace();
  }

  ngAfterViewInit(): void {
    const smartScrollEl = this.smartScrollRef?.nativeElement;
    if (!smartScrollEl) {
      return;
    }

    this.navbarResizeObserver = new ResizeObserver((entries) => {
      const height = entries[0]?.target.getBoundingClientRect().height ?? 0;
      document.documentElement.style.setProperty(
        '--fixed-navbar-height',
        `${height}px`,
      );
    });
    this.navbarResizeObserver.observe(smartScrollEl);
  }

  ngOnDestroy(): void {
    this.navbarResizeObserver?.disconnect();
  }

  /**
   * APP_URL is `http://localhost:4200/#/`, so magic links arrive as a hash.
   * Routing is path-based, so that URL otherwise stays on the public home.
   */
  private openMagicLinkFromHash(): void {
    const raw = window.location.hash.replace(/^#/, '');
    if (!raw.startsWith('/auth/magic')) {
      return;
    }
    if (this.router.url.split('?')[0] === '/auth/magic') {
      return;
    }
    const queryIndex = raw.indexOf('?');
    const params = new URLSearchParams(
      queryIndex >= 0 ? raw.slice(queryIndex + 1) : '',
    );
    const token = params.get('token')?.trim();
    if (!token) {
      return;
    }
    void this.router.navigate(['/auth', 'magic'], {
      queryParams: { token },
      replaceUrl: true,
    });
  }

  private isHomeUrl(url: string): boolean {
    const path = url.split('?')[0].split('#')[0];
    return path === '/' || path === '';
  }
}
